export default (target = '.draggable', speed = 1, ajax = false) => {
  const active = `${target.replace('.', '')}--active`;
  let startX;
  let scrollLeft;
  let isMouseDown = false;

  const getContainer = (e) =>
    e.target.matches(target) ? e.target : e.target.closest(target);

  const setupScroll = (e) => {
    const container = getContainer(e);
    if (!container) return;

    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
    isMouseDown = true;
    
  };

  const finishScroll = (e) => {
    isMouseDown = false;
    [...document.querySelectorAll(target)].map((el) =>
      setTimeout(() => el.classList.remove(active), 100)
    );
  };

  const scroll = (e) => {
    if (!isMouseDown) return;

    const container = getContainer(e);
    if (!container) return;

    e.preventDefault();

    setTimeout(() => container.classList.add(active), 100);
    const currentX = e.pageX - container.offsetLeft;
    const distanceTravelled = (currentX - startX) * speed;
    container.scrollLeft = scrollLeft - distanceTravelled;
  };

  const setupEvents = (method = 'add') => {
    document[`${method}EventListener`]('mousedown', setupScroll, true);
    [...document.querySelectorAll(target)].map((el) =>
      el[`${method}EventListener`]('mouseleave', finishScroll)
    );
    document[`${method}EventListener`]('mouseup', finishScroll);
    document[`${method}EventListener`]('mousemove', scroll, true);
  };

  setupEvents();
  if (ajax) {
    document.addEventListener('change', () => {
      setupEvents('remove');
      setupEvents('add');
    });
  }
};
